// src/services/mealService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  MEAL_LIST,
  EMAIL_TEMPLATE_LIST,
  EMAIL_TEMPLATE_UPDATE,
 
  MEAL_UPDATE,
  
} from "../../config/constants"; // Adjust endpoints as per your config

const emailService = createApi({
  reducerPath: "emailService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["EmailTemp"],
  endpoints: (builder) => ({

    getEmailTemplate: builder.query({
      query: (bodyData) => ({
        url: EMAIL_TEMPLATE_LIST, // Endpoint to fetch meal list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["EmailTemp"],
    }),
    
    updateEmailTemplate: builder.mutation({
      query: ({ mealId, updatedData }) => ({
        url: `${EMAIL_TEMPLATE_UPDATE}/${mealId}`, // Endpoint to update a meal
        method: "PUT",
        data: updatedData, // Updated meal data
      }),
      invalidatesTags: ["EmailTemp"]
    }),
    
   
  }),
});

// Export hooks for usage in functional components
export const {
  useGetEmailTemplateQuery,
  //useAddMealMutation,
  //useAddStaffMutation,
  useUpdateEmailTemplateMutation,
  //useDeleteMealMutation,
} = emailService;

// Export the reducer to be included in the store
export default emailService;
